module.exports = __webpack_public_path__ + "static/paris-014-f647437591ed97010987f7b496be3993.jpg";